export default function TriImage(props){
  return <>
     <div className={`triSec ${props.mainclass}`} >
         <div><img src={props.img1} className="img-fluid" alt="image" /></div>
         <div><img src={props.img2} className="img-fluid" alt="image" /></div>
         <div><img src={props.img3} className="img-fluid" alt="image" /></div>
     </div>
  </>
}
